export const nl2br = (str) => {
    if (!str) return '';
    return str.split('\n').join('<br>');
};
